import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { CyptolandingComponent } from './cyptolanding/cyptolanding.component';
import { Page404Component } from './extrapages/page404/page404.component';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'admin', component: LayoutComponent, loadChildren: () => import('./nt-app/admin/admin.module').then(m => m.AdminModule), canActivate: [AuthGuard] },
  {
    path: 'contacts',
    component: LayoutComponent,
    loadChildren: () => import('./nt-app/entity-directory/entity-directory.module').then(m => m.EntityDirectoryModule),
    canActivate: [AuthGuard],
    data: { mode: 'contacts', title: 'Contacts' }
  },
  {
    path: 'address',
    component: LayoutComponent,
    loadChildren: () => import('./nt-app/entity-directory/entity-directory.module').then(m => m.EntityDirectoryModule),
    canActivate: [AuthGuard],
    data: { mode: 'addresses', title: 'Addresses' }
  },
  { path: 'daily_bin', component: LayoutComponent, loadChildren: () => import('./nt-app/daily-bin/daily-bin.module').then(m => m.DailyBinModule), canActivate: [AuthGuard] },
  { path: 'announcements', component: LayoutComponent, loadChildren: () => import('./nt-app/announcements/announcements.module').then(m => m.AnnouncementsModule), canActivate: [AuthGuard] },
  { path: 'tasks', component: LayoutComponent, loadChildren: () => import('./nt-app/tasks/tasks.module').then(m => m.TasksModule), canActivate: [AuthGuard] },
  { path: 'hrm', component: LayoutComponent, loadChildren: () => import('./nt-app/hrm/hrm.module').then(m => m.HrmModule), canActivate: [AuthGuard] },
  { path: 'order-requests', component: LayoutComponent, loadChildren: () => import('./nt-app/order-requests/order-requests.module').then(m => m.OrderRequestsModule), canActivate: [AuthGuard] },
  { path: 'orders', component: LayoutComponent, loadChildren: () => import('./nt-app/orders/orders.module').then(m => m.OrdersModule), canActivate: [AuthGuard] },

  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule), canActivate: [AuthGuard] },
  { path: 'crypto-ico-landing', component: CyptolandingComponent },
  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
